
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M496 319.992c-8.832 0-16 7.168-16 16v112H32V231.64l218.048 87.232a16.213 16.213 0 005.952 1.12c6.336 0 12.352-3.808 14.848-10.048 3.296-8.192-.704-17.504-8.928-20.8l-229.92-92v-37.152h176c8.832 0 16-7.168 16-16s-7.168-16-16-16H32c-17.632 0-32 14.368-32 32v288c0 17.632 14.368 32 32 32h448c17.632 0 32-14.368 32-32v-112c0-8.832-7.168-16-16-16z"}}),_c('path',{attrs:{"d":"M502.304 81.304l-112-48a15.98 15.98 0 00-12.608 0l-112 48C259.808 83.8 256 89.592 256 95.992v64c0 88.032 32.544 139.488 120 189.856 2.496 1.44 5.248 2.144 8 2.144s5.504-.704 7.968-2.112C479.456 299.608 512 248.152 512 159.992v-64c0-6.4-3.808-12.192-9.696-14.688zM480 159.992c0 73.888-24.448 114.592-96 157.44-71.552-42.976-96-83.648-96-157.44v-53.44L384 65.4l96 41.152v53.44z"}}),_c('path',{attrs:{"d":"M442.016 131.448c-6.912-5.504-16.96-4.352-22.496 2.496l-50.336 62.912-19.872-29.728c-4.896-7.328-14.816-9.344-22.176-4.448s-9.344 14.816-4.448 22.176l32 48c2.816 4.256 7.52 6.88 12.64 7.104H368c4.832 0 9.44-2.208 12.512-6.016l64-80c5.504-6.912 4.384-16.96-2.496-22.496z"}})])
          )
        }
      }
    